const breakpoints = {
	xs: '320px',
	sm: '576px',
	md: '768px',
	lg: '1024px',
	xl: '1280px',
	'2xl': '1440px',
	'3xl': '1600px',
	'4xl': '1920px',
	'5xl': '2560px',
};

export default breakpoints;
